<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header">
        <v-layout align-center justify-start>
          <v-flex xs12 class="pa-5">
            <promotional-laboral-dashboard></promotional-laboral-dashboard>
          </v-flex>
        </v-layout>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>
<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import PromotionalLaboralDashboard from '../components/PromotionalLaboralDashboard.vue';

import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';

export default {
  components: {
    DashboardLayout,
    MyConsultantConversation,
    CalendarEvents,
    AppLayout,
    PromotionalLaboralDashboard,
  },
};
</script>
